// Shared money formatting utility
// Handles both ISO currency codes (THB) and display symbols (฿)

const normalizeCurrency = (currency?: string) => {
  if (!currency) return 'THB'
  const c = currency.toUpperCase()
  if (c === 'RS.' || c === 'RS') return 'THB'
  return c
}

const displayCurrencyLabel = (currency?: string) => {
  if (!currency) return 'THB'
  const c = currency.toUpperCase()
  if (c === 'THB') return 'THB'
  return c
}

export function formatMoney(amount: number, currency?: string): string {
  const iso = normalizeCurrency(currency)
  const label = displayCurrencyLabel(currency)
  const formatted = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number.isFinite(amount) ? amount : 0)
  return `${label} ${formatted}`
}
